import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {Img} from 'ui';

export const Image = styled(Img)({
  width: 275,
  height: 209,
  backgroundSize: 'cover',
});

export const Article = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  textDecoration: 'none',
  marginLeft: 16,
  width: 275,
  // height: 279,
});

export const ArticleTitle = styled('p')({
  fontSize: 16,
  lineHeight: '19px',
  fontWeight: 'bold',
  color: colors.black,
  fontFamily: fonts.title,
  textAlign: 'center',
  textDecoration: 'none',
  height: 70,
  padding: '16px 12px',
  backgroundColor: colors.white,
  marginTop: 0,
  marginBottom: 8,
});
